import React from 'react';
import { Outlet } from 'react-router-dom';
import { AuthLayout, ConfirmAccountView } from '../../components/auth';

interface Props {}

export const ConfirmAccountPage: React.FC<Props> = () => {
  return (
    <>
      <AuthLayout>
        <div className='flex justify-center md:mt-[3em] lg:hidden 375:ml-[8em] 414:ml-[10em] 360:ml-[8em] 412:ml-[9em] 540:ml-[13em] bigmd:ml-[24em]  w-[99.56px] mt-[2em] md:ml-[20em] md:w-[160px] '>
        </div>
        <div className="bg-[#F2F9FD]">
      <ConfirmAccountView />
    </div>
       

        <Outlet />
      </AuthLayout>
    </>
  );
};
